import React from 'react';
import { motion } from 'framer-motion';
export function Chapters() {
  const chapters = [{
    icon: '📘',
    num: '01',
    title: 'Antes de ser mamá',
    desc: 'Aprendé a entender el embarazo desde un lugar más tranquilo, humano y real.',
    topics: ['Dudas y miedos normales', 'Primeras semanas', 'Controles del embarazo', 'Cambios emocionales', 'Qué esperar en cada trimestre']
  }, {
    icon: '📗',
    num: '02',
    title: 'Nacimiento y parto',
    desc: 'Todo lo que necesitás saber para llegar al parto con más calma y claridad.',
    topics: ['Señales del parto', 'Contracciones reales vs falsas', 'Qué llevar a la clínica', 'Cómo prepararte emocionalmente', 'Primer contacto con tu bebé']
  }, {
    icon: '📙',
    num: '03',
    title: 'Posparto y cuidados del recién nacido',
    desc: 'La etapa que más dudas genera, explicada de forma simple y tranquila.',
    topics: ['Sueño del recién nacido', 'Alimentación', 'Llanto del bebé', 'Cordón umbilical', 'Qué es normal y qué no']
  }, {
    icon: '📕',
    num: '04',
    title: 'Problemas comunes del bebé',
    desc: 'Aprendé a reconocer señales importantes sin entrar en pánico.',
    topics: ['Cólicos', 'Gases', 'Fiebre', 'Regurgitación', 'Cuándo consultar']
  }, {
    icon: '📓',
    num: '05',
    title: 'Seguridad y confianza como mamá',
    desc: 'Dejá de sentir que todo el tiempo lo estás haciendo mal.',
    topics: ['Culpa materna', 'Comparación', 'Presión externa', 'Cómo confiar más en vos', 'Recuperar tranquilidad']
  }, {
    icon: '📔',
    num: '06',
    title: 'Acompañamiento emocional y maternidad real',
    desc: 'Una mirada más humana y empática sobre la maternidad.',
    topics: ['Ansiedad y emociones', 'Cambios internos', 'Cansancio emocional', 'Autoexigencia', 'Maternidad sin perfección']
  }];
  return <section className="py-20 md:py-28 bg-cream" data-id="element-45">
      <div className="max-w-6xl mx-auto px-6" data-id="element-46">
        <div className="text-center mb-16" data-id="element-47">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-48">
            📚 EL CONTENIDO
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-49">
            6 capítulos pensados para acompañarte
          </h2>
          <p className="font-serif italic text-xl md:text-2xl text-peach-dark" data-id="element-50">
            Más de 180 páginas paso a paso
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-51">
          {chapters.map((ch, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-peach-light/50 hover:shadow-lg transition-shadow" data-id="element-52">
              <div className="flex items-center gap-3 mb-6" data-id="element-53">
                <span className="text-4xl" data-id="element-54">{ch.icon}</span>
                <div data-id="element-55">
                  <span className="text-xs font-bold tracking-widest text-peach-dark uppercase" data-id="element-56">
                    CAPÍTULO {ch.num}
                  </span>
                  <h3 className="text-xl font-serif font-bold text-text-dark leading-tight mt-1" data-id="element-57">
                    {ch.title}
                  </h3>
                </div>
              </div>
              <p className="text-text-muted mb-6 min-h-[3.5rem]" data-id="element-58">{ch.desc}</p>
              <ul className="space-y-2" data-id="element-59">
                {ch.topics.map((topic, tidx) => <li key={tidx} className="flex items-start gap-2 text-sm text-text-dark" data-id="element-60">
                    <span className="text-peach shrink-0" data-id="element-61">🌸</span>
                    <span data-id="element-62">{topic}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}